import React, { useRef, useState, useEffect } from "react";
import NavBar from "../NavBar/NavBar.tsx";
import Help from "../Help Section/Help";
import Footer from "../Footer/Footer.tsx";
import { useHistory } from "react-router-dom";
import CompanySlider from "../CompanySlider/CompanySlider.tsx";
import { PortfolioBanner, PortfolioSubBanner } from "../../Assets.tsx";
import OurApproach from "../Our Approach/OurApproach.tsx";
import ScrollToTopButton from "../Common-component/ScrollToTopButton.tsx";

/* Colours: text #4e5356 | buttons #2596be | headings #4573a6 | background white
   Fonts  : Ubuntu Bold (headings) / Open Sans Regular (body) */

const focusCards = [
  { title: "Latest Trends", text: "Apps built around the newest technology and market demands.", icon: <path d="M3 17l6-6 4 4 8-8M15 7h6v6" /> },
  { title: "Measurable Results", text: "We help you reach your target audience and get real, measurable results.", icon: <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="4.5" /><circle cx="12" cy="12" r="0.8" /></> },
  { title: "Full Digital Suite", text: "From brainstorming through monetization and beyond.", icon: <><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></> },
  { title: "Native On Every Platform", text: "Smooth native apps with an excellent user experience on all major platforms.", icon: <><rect x="7" y="2" width="10" height="20" rx="2.5" /><path d="M11 18h2" /></> },
];

const STYLES = `
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&family=Ubuntu:wght@700&display=swap");

.pf{--text:#4e5356;--head:#4573a6;--btn:#2596be;--tint:#eef6fa;--line:#d3e4ed;
  position:relative;overflow:hidden;background:#fff;font-family:"Open Sans",sans-serif;font-weight:400;color:var(--text)}
.pf-in{display:flex;align-items:center;justify-content:space-between;gap:60px;max-width:1240px;margin:0 auto}

/* shared bits */
.pf-chip{display:inline-block;margin-bottom:16px;padding:6px 18px;border-radius:50px;background:var(--tint);border:1px solid var(--line);
  color:var(--head);font-size:12px;letter-spacing:2px;text-transform:uppercase}
.pf h1,.pf h2{margin:0 0 16px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:42px;line-height:1.15;color:var(--head);cursor:default;transition:color .35s,letter-spacing .35s}
.pf h1:hover,.pf h2:hover{color:var(--btn);letter-spacing:.6px}
.pf-line{display:flex;align-items:center;gap:12px;margin-bottom:20px}
.pf-line i{display:block;height:2px;width:40px;border-radius:2px;background:var(--btn)}.pf-line i:last-child{background:var(--head)}
.pf-text p{margin:0 0 16px;font-size:14.5px;line-height:1.75;color:var(--text)}

.pf-tags{display:flex;flex-wrap:wrap;gap:10px;margin:22px 0 30px}
.pf-tag{position:relative;overflow:hidden;z-index:0;padding:7px 18px;border-radius:50px;background:var(--tint);border:1px solid var(--line);color:var(--head);
  font-size:14px;font-weight:600;cursor:default;transition:color .35s,border-color .35s,transform .35s cubic-bezier(.3,1.6,.5,1)}
.pf-tag::before{content:"";position:absolute;inset:0;z-index:-1;background:linear-gradient(90deg,var(--head),var(--btn));transform:translateY(101%);transition:transform .4s cubic-bezier(.2,.8,.2,1)}
.pf-tag:hover{color:#fff;border-color:transparent;transform:translateY(-3px)}
.pf-tag:hover::before{transform:none}

/* button = same as .op-btn */
.pf-btn{position:relative;overflow:hidden;z-index:0;display:inline-flex;align-items:center;gap:8px;padding:12px 28px;border:none;border-radius:50px;
  background:var(--tint);color:var(--head);font-family:"Open Sans",sans-serif;font-weight:600;font-size:14px;cursor:pointer;box-shadow:0 0 0 1px var(--line) inset;
  transition:color .35s,transform .35s cubic-bezier(.3,1.6,.5,1),box-shadow .35s}
.pf-btn::before{content:"";position:absolute;inset:0;z-index:-1;background:linear-gradient(90deg,var(--head),var(--btn));transform:translateX(-101%);transition:transform .45s cubic-bezier(.2,.8,.2,1)}
.pf-btn:hover{color:#fff;transform:translateY(-3px);box-shadow:0 16px 26px -12px rgba(37,150,190,.7)}
.pf-btn:hover::before{transform:none}
.pf-btn span{display:inline-block;transition:transform .35s}
.pf-btn:hover span{transform:translateX(5px)}

/* ---------- HERO ---------- */
.pf-hero{padding:150px 24px 90px}
.pf-text{flex:1;min-width:0;max-width:560px;animation:pfL .9s cubic-bezier(.2,.8,.2,1) backwards}
.pf-vis{position:relative;flex:none;width:46%;max-width:540px;animation:pfR .9s .15s cubic-bezier(.2,.8,.2,1) backwards}
.pf-ring{position:absolute;inset:-14px;border-radius:44px;overflow:hidden}
.pf-ring::before{content:"";position:absolute;left:50%;top:50%;width:200%;height:200%;margin:-100% 0 0 -100%;
  background:conic-gradient(from 0deg,#4573a6,#2596be,#a9d3e6,#4573a6);animation:pfSpin 8s linear infinite}
.pf-ring::after{content:"";position:absolute;inset:4px;border-radius:40px;background:#fff}
.pf-tilt{position:relative;padding:28px;border-radius:32px;background:#fff;border:1px solid var(--line);box-shadow:0 30px 50px -26px rgba(69,115,166,.5);
  transition:transform .15s ease-out;transform:perspective(900px) rotateX(0) rotateY(0)}
.pf-tilt img{display:block;width:100%;height:auto;object-fit:contain}
.pf-chipf{position:absolute;z-index:3;display:flex;align-items:center;gap:10px;padding:10px 16px;border-radius:16px;background:#fff;
  border:1px solid var(--line);box-shadow:0 18px 30px -16px rgba(69,115,166,.55);font-size:13px;color:var(--text);white-space:nowrap}
.pf-chipf b{display:block;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:15px;color:var(--head)}
.pf-chipf .dot{width:34px;height:34px;border-radius:10px;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;background:linear-gradient(135deg,var(--head),var(--btn))}
.pf-chipf.c1{left:-34px;bottom:44px;animation:pfFloat 5s ease-in-out infinite}
.pf-chipf.c2{right:-24px;top:34px;animation:pfFloat 6s -2s ease-in-out infinite}

/* ---------- FOCUS ---------- */
.pf-focus{padding:60px 24px 100px}
.pf-focus-vis{position:relative;flex:none;width:42%;max-width:480px}
.pf-focus-vis::before{content:"";position:absolute;inset:-18px 18px 18px -18px;border-radius:32px;background:var(--tint);border:1px solid var(--line)}
.pf-focus-vis img{position:relative;display:block;width:100%;height:auto;object-fit:contain;padding:22px;border-radius:32px;background:#fff;border:1px solid var(--line);
  box-shadow:0 30px 50px -26px rgba(69,115,166,.5);transition:transform .5s cubic-bezier(.3,1.4,.5,1)}
.pf-focus-vis:hover img{transform:translateY(-8px)}
.pf-focus-text{flex:1;min-width:0;max-width:600px}
.pf-focus h2{font-size:34px}
.pf-fin:not(.in) .pf-focus-vis,.pf-fin:not(.in) .pf-focus-text{opacity:0}
.pf-fin.in .pf-focus-vis{animation:pfL .9s cubic-bezier(.2,.8,.2,1) backwards}
.pf-fin.in .pf-focus-text{animation:pfR .9s .12s cubic-bezier(.2,.8,.2,1) backwards}

/* cards */
.pf-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:22px;max-width:1240px;margin:90px auto 0}
.pf-grid:not(.in) .pf-card{opacity:0}
.pf-grid.in .pf-card{animation:pfRise .8s cubic-bezier(.2,.8,.2,1) backwards;animation-delay:calc(var(--i) * .12s)}
.pf-card{--mx:50%;--my:50%;--rx:0deg;--ry:0deg;position:relative;overflow:hidden;text-align:center;padding:36px 22px 30px;border-radius:24px;
  background:#fff;border:1px solid var(--line);box-shadow:0 18px 36px -26px rgba(69,115,166,.55);
  transform:perspective(900px) rotateX(var(--rx)) rotateY(var(--ry));transition:transform .18s ease-out,box-shadow .4s,border-color .4s}
.pf-card:hover{border-color:transparent;box-shadow:0 30px 50px -22px rgba(37,150,190,.7)}
.pf-glow{position:absolute;inset:0;pointer-events:none;opacity:0;transition:opacity .35s;
  background:radial-gradient(240px circle at var(--mx) var(--my),rgba(37,150,190,.16),rgba(69,115,166,.05) 45%,transparent 70%)}
.pf-card:hover .pf-glow{opacity:1}
.pf-top{position:absolute;top:0;left:0;width:100%;height:5px;transform:scaleX(0);transform-origin:left;background:linear-gradient(90deg,var(--head),var(--btn));transition:transform .55s cubic-bezier(.2,.8,.2,1)}
.pf-card:hover .pf-top{transform:scaleX(1)}
.pf-num{position:absolute;top:10px;right:14px;font-size:54px;font-weight:800;line-height:1;pointer-events:none;color:transparent;-webkit-text-stroke:1.5px rgba(69,115,166,.14);
  transition:transform .5s cubic-bezier(.2,.8,.2,1),-webkit-text-stroke-color .4s}
.pf-card:hover .pf-num{transform:translate(4px,-4px);-webkit-text-stroke-color:rgba(37,150,190,.4)}
.pf-icon{position:relative;width:84px;height:84px;margin:0 auto 20px;border-radius:24px;background:var(--tint);display:flex;align-items:center;justify-content:center;
  transition:background .4s,box-shadow .4s,transform .5s cubic-bezier(.3,1.4,.5,1)}
.pf-icon svg{width:36px;height:36px;fill:none;stroke:var(--head);stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;transition:stroke .4s,transform .5s cubic-bezier(.3,1.4,.5,1)}
.pf-card:hover .pf-icon{background:linear-gradient(135deg,var(--head),var(--btn));transform:translateY(-6px);box-shadow:0 10px 22px -8px rgba(37,150,190,.6)}
.pf-card:hover .pf-icon svg{stroke:#fff;transform:scale(1.1)}
.pf-card h3{position:relative;display:inline-block;margin:0 0 12px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:20px;letter-spacing:.6px;color:var(--head)}
.pf-card h3::after{content:"";position:absolute;left:0;bottom:-5px;height:2px;width:0;background:var(--btn);transition:width .45s cubic-bezier(.2,.8,.2,1)}
.pf-card:hover h3::after{width:100%}
.pf-card p{position:relative;margin:0;font-size:14.5px;line-height:1.75;color:var(--text)}

@keyframes pfL{from{opacity:0;transform:translateX(-70px)}}
@keyframes pfR{from{opacity:0;transform:translateX(70px)}}
@keyframes pfRise{from{opacity:0;transform:translateY(60px)}}
@keyframes pfSpin{to{transform:rotate(360deg)}}
@keyframes pfFloat{50%{transform:translateY(-12px)}}

@media(max-width:1100px){.pf-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}
@media(max-width:960px){
  .pf-hero{padding:120px 18px 70px}
  .pf-in{flex-direction:column;gap:64px}
  .pf-focus .pf-in{flex-direction:column-reverse}
  .pf-text,.pf-focus-text{max-width:100%}
  .pf-vis,.pf-focus-vis{width:100%;max-width:420px}
  .pf-chipf.c1{left:-8px}.pf-chipf.c2{right:-8px}
  .pf-focus{padding:40px 18px 80px}
  .pf-grid{margin-top:70px}
}
@media(max-width:600px){
  .pf h1,.pf h2{font-size:30px}.pf-focus h2{font-size:28px}
  .pf-grid{grid-template-columns:1fr}
}
@media(prefers-reduced-motion:reduce){
  .pf *,.pf *::before,.pf *::after{animation:none!important;transition:none!important}
  .pf-fin .pf-focus-vis,.pf-fin .pf-focus-text,.pf-grid .pf-card{opacity:1!important}
}
`;

/* true once the element has scrolled into view */
const useInView = (threshold) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return [ref, inView];
};

const FocusCard = ({ item, index }) => {
  const ref = useRef(null);

  const handleMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const x = e.clientX - r.left;
    const y = e.clientY - r.top;
    el.style.setProperty("--mx", x + "px");
    el.style.setProperty("--my", y + "px");
    el.style.setProperty("--ry", ((x / r.width - 0.5) * 8).toFixed(2) + "deg");
    el.style.setProperty("--rx", ((0.5 - y / r.height) * 8).toFixed(2) + "deg");
  };

  const handleLeave = () => {
    if (!ref.current) return;
    ref.current.style.setProperty("--rx", "0deg");
    ref.current.style.setProperty("--ry", "0deg");
  };

  return (
    <div
      className="pf-card"
      ref={ref}
      style={{ "--i": index }}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
    >
      <div className="pf-top" />
      <div className="pf-glow" />
      <span className="pf-num">{String(index + 1).padStart(2, "0")}</span>
      <div className="pf-icon">
        <svg viewBox="0 0 24 24">{item.icon}</svg>
      </div>
      <h3>{item.title}</h3>
      <p>{item.text}</p>
    </div>
  );
};

const PortfolioPage = () => {
  const history = useHistory();
  const tiltRef = useRef(null);
  const [focusRef, focusIn] = useInView(0.2);
  const [gridRef, gridIn] = useInView(0.15);

  // gentle 3D tilt on the hero image
  const handleMove = (e) => {
    const el = tiltRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const ry = ((e.clientX - r.left) / r.width - 0.5) * 10;
    const rx = ((e.clientY - r.top) / r.height - 0.5) * -10;
    el.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg)`;
  };

  const handleLeave = () => {
    if (tiltRef.current) {
      tiltRef.current.style.transform = "perspective(900px) rotateX(0deg) rotateY(0deg)";
    }
  };

  return (
    <div>
      <NavBar />
      <style>{STYLES}</style>

      {/* HERO */}
      <div className="pf pf-hero">
        <div className="pf-in">
          <div className="pf-text">
            <div className="pf-chip">Our Portfolio</div>
            <h1>Our Quality Speaks For Itself.</h1>
            <div className="pf-line"><i /><i /></div>
            <p>
              Over the years, we have developed several applications for both Android and iOS. You can look
              at some of our top projects in our portfolio.
            </p>
            <div className="pf-tags">
              <span className="pf-tag">Android</span>
              <span className="pf-tag">iOS</span>
              <span className="pf-tag">Native Apps</span>
            </div>
            <button className="pf-btn" onClick={() => history.push("/contact")}>
              Get Started <span>→</span>
            </button>
          </div>

          <div className="pf-vis" onMouseMove={handleMove} onMouseLeave={handleLeave}>
            <div className="pf-ring" />
            <div className="pf-tilt" ref={tiltRef}>
              <img src={PortfolioBanner} alt="ATUM portfolio" />
            </div>
            <div className="pf-chipf c1">
              <span className="dot">✓</span>
              <div>Quality<b>First</b></div>
            </div>
            <div className="pf-chipf c2">
              <span className="dot">★</span>
              <div>Top<b>Projects</b></div>
            </div>
          </div>
        </div>
      </div>

      {/* OUR FOCUS */}
      <div className={"pf pf-focus pf-fin" + (focusIn ? " in" : "")} ref={focusRef}>
        <div className="pf-in">
          <div className="pf-focus-vis">
            <img src={PortfolioSubBanner} alt="Our focus" />
          </div>
          <div className="pf-text pf-focus-text">
            <div className="pf-chip">Our Focus</div>
            <h2>Quality is our only focus.</h2>
            <div className="pf-line"><i /><i /></div>
            <p>
              We are one of the best app development companies in India, and we place a high value on creating
              high-quality apps that follow the latest trends in technology and market demands. Our team aims to
              help our clients connect with their target audience and create real, measurable results for their
              businesses. We have a full suite of digital services ready to help you succeed, from brainstorming
              through monetization and beyond.
            </p>
            <p>
              Using cutting-edge tools, we design and develop native applications that run smoothly on all major
              platforms and provide an excellent user experience. Given the diversity of platform technologies,
              we take special care to use the most appropriate tool while creating our applications.
            </p>
          </div>
        </div>

        <div className={"pf-grid" + (gridIn ? " in" : "")} ref={gridRef}>
          {focusCards.map((c, i) => (
            <FocusCard key={c.title} item={c} index={i} />
          ))}
        </div>
      </div>

      {/* our approach section */}
      <OurApproach />

      {/* clients (the slider has its own heading) */}
      <CompanySlider />

      <ScrollToTopButton />

      {/* help section */}
      <Help />

      {/* footer section */}
      <Footer />
    </div>
  );
};

export default PortfolioPage;